import Box from '@mui/material/Box';
import { ReactNode } from 'react';

import DisplayHeadingWithRule from 'src/common/components/DisplayHeadingWithRule';
import { dashboardPageHeaderActionsSx } from 'src/common/components/DashboardPageToolbar';

interface PageBlocksSectionHeaderProps {
  title: string;
  actions?: ReactNode;
}

export default function PageBlocksSectionHeader({ title, actions }: PageBlocksSectionHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        mb: 2,
        minWidth: 0,
      }}
    >
      <DisplayHeadingWithRule variant="h6" component="h3" sx={{ flex: 1, minWidth: 0 }}>
        {title}
      </DisplayHeadingWithRule>
      {actions ? <Box sx={dashboardPageHeaderActionsSx}>{actions}</Box> : null}
    </Box>
  );
}
